/* eslint-disable import/first */

//region 1. Platform Libraries
const request = require('supertest');
//endregion

//region 2. Project Libraries
import DataAPI from '../DataAPI';
//endregion

describe('Route /health', () => {
        const dataAPI = new DataAPI();

        before(function before(done) {
                this.timeout(3000);
                dataAPI.initialize({ mongoUrl: process.env.CLIO_MONGO_URL });
                dataAPI.start(done);
        });

        describe('GET', () => {
                it('should return 200', (done) => {
                        request(dataAPI.expressApp)
                        .get('/health')
                        .expect(200)
                        .expect((res) => {
                                if (res.text !== 'HEALTHY') {
                                        throw new Error('Invalid Health Check Response');
                                }
                        })
                        .end(/** @type function */done);
                });
        });

        after(done => dataAPI.stop(done));
});
